import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../services/firebase';
import { getUserById } from '../../utils/userUtils';

export const useProfile = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Fetch user profile info on mount and poll for updates
  useEffect(() => {
    const loadUserProfile = async () => {
      const user = auth.currentUser;
      if (!user) {
        navigate('/login');
        return;
      }

      try {
        const userObj = await getUserById(user.uid);
        setUserData(userObj || { 
          name: user.displayName || 'New User', 
          email: user.email 
        });
      } catch (error) {
        setUserData({ 
          name: user.displayName || 'New User', 
          email: user.email 
        });
      } finally {
        setLoading(false);
      }
    };

    loadUserProfile();

    // Poll for profile updates every 3 seconds
    const interval = setInterval(loadUserProfile, 3000);
    return () => clearInterval(interval);
  }, [navigate]);

  const handleEditProfile = () => {
    navigate('/edit-profile');
  };

  return {
    userData,
    loading,
    handleEditProfile
  };
};